"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConceptOfferHint = void 0;
var _basketUpdated = require("@ori-events/basket-updated");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _Header = require("../Header");
var _Item = require("../Item");
var _Section = require("../Modal/Section");
var _OfferAction = require("../OfferAction");
var _SeeAllBanner = require("../SeeAllBanner");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const ConceptOfferHint = ({
  dialogRef,
  offer
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    benefits,
    benefitsQuantity,
    description,
    discountPercent,
    displayedItems1stSection,
    displayedItems2ndSection,
    handleAddConceptOffer,
    itemsCount1stSection,
    itemsCount2ndSection,
    isAdding,
    isChooseAndChoose,
    isOfferActionDisabled,
    offerId,
    offerType,
    requiredQuantity,
    seeAllItems2ndSectionHandler,
    seeAllItems1stSectionHandler,
    selectedFirstSectionItemsCount,
    shouldShowSeeAllBanner1stSection,
    shouldShowSeeAllBanner2ndSection,
    totalPrices
  } = (0, _hooks.useConceptOfferHintData)(offer);
  const {
    infoBannerRef,
    offerRef
  } = (0, _hooks.useConceptOfferHintScrollEffects)(dialogRef);
  const {
    buyProductsTitle,
    chooseTitle,
    chooseUpToTitle,
    formattedPrecentDiscount,
    getOfferTitle
  } = (0, _hooks.useConceptOfferHintTranslations)({
    benefitsQuantity,
    requiredQuantity,
    discountPercent
  });
  (0, _logger.logDebug)('>>> rendering concept offer hint', offerId);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_shared.OfferHintWrapper, {
    ref: offerRef,
    "data-testid": getTestId(`offer-${offerId}`),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.Header, {
      "data-testid": getTestId('offer-header'),
      description: description,
      dialogRef: dialogRef,
      title: chooseTitle
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.OfferInfo, {
      ref: infoBannerRef,
      countSelected: selectedFirstSectionItemsCount,
      "data-testid": getTestId('sticky-offer-info'),
      requiredQuantity: requiredQuantity
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_shared.Content, {
      "data-testid": getTestId('offer-content'),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Section.ModalSection, {
        title: buyProductsTitle,
        children: [displayedItems1stSection.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Item.ItemBox, {
          formattedPrecentDiscount: formattedPrecentDiscount,
          "data-testid": getTestId(`offer-item-${item.itemCode}`),
          isBadgeDisplayed: false,
          ...item
        }, `offer-item-${item.itemCode}`)), shouldShowSeeAllBanner1stSection ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SeeAllBanner.SeeAllBanner, {
          count: itemsCount1stSection,
          "data-testid": getTestId('see-all-banner'),
          onClick: seeAllItems1stSectionHandler
        }) : null]
      }), offerType === _basketUpdated.BasketOfferTypes.CHOOSE_WITH_DISCOUNT && discountPercent !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Section.ModalSection, {
        title: getOfferTitle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Item.DiscountRow, {
          countProducts: requiredQuantity,
          discount: discountPercent
        })
      }), offerType === _basketUpdated.BasketOfferTypes.CHOOSE_AND_GET && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Section.ModalSection, {
        title: getOfferTitle,
        children: benefits.map(benefit => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Item.ItemRow, {
          "data-testid": getTestId(`benefit-item-${benefit.itemCode}`),
          ...benefit,
          isPurchased: false,
          selectedQuantity: benefit.quantity
        }, `benefit-item-${benefit.itemCode}`))
      }), isChooseAndChoose ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Section.ModalSection, {
        title: chooseUpToTitle,
        children: [displayedItems2ndSection.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Item.ItemBox, {
          isBadgeDisplayed: true,
          formattedPrecentDiscount: formattedPrecentDiscount,
          "data-testid": getTestId(`benefit-item-${item.itemCode}`),
          ...item
        }, `benefit-item-${item.itemCode}`)), shouldShowSeeAllBanner2ndSection ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SeeAllBanner.SeeAllBanner, {
          count: itemsCount2ndSection,
          "data-testid": getTestId('see-all-banner'),
          onClick: seeAllItems2ndSectionHandler
        }) : null]
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferAction.OfferAction, {
        isAdding: isAdding,
        isDisabled: isOfferActionDisabled,
        totalPrice: totalPrices.price,
        totalPurchasePrice: totalPrices.purchasePrice,
        onAddOffer: handleAddConceptOffer
      })]
    })]
  });
};
exports.ConceptOfferHint = ConceptOfferHint;